import styled, { css } from "styled-components";

export const Img = styled.img`
  max-width: 100%;
  max-height: 100%;
  ${p => p.fullscreen ? css`max-width: unset; max-height: unset;`: ''}
  width:fit-content;
  object-fit: contain;
`;
